import SpaLink from 'components/SpaLink/SpaLink';
import { CategoryTag } from 'frontend/types';
import styles from './CategoryTags.module.css';
import classnames from 'classnames';
import DropDown from 'components/DropDown/DropDown';
import { categoryTagsMenuClick } from 'frontend/utils/analytics/dataLayerDispatchers';
interface Props {
  tags: CategoryTag[];
  categoryName: string;
  activeTag?: CategoryTag;
  currentSlug?: string;
}
const CategoryTags = ({
  tags,
  categoryName,
  currentSlug,
  activeTag
}: Props) => {
  return <>
      <nav data-testid="desktop-navigation" className={styles.desktopWrapper}>
        <ul className={styles.tagList}>
          {tags.map(tag => <li key={tag.slug}>
              <SpaLink aria-current={currentSlug === tag.slug ? 'true' : 'false'} href={tag.link} className={classnames(styles.tagLink, {
            [`${styles.isActive}`]: currentSlug === tag.slug
          })} onClick={() => {
            categoryTagsMenuClick(categoryName, tag.name);
          }}>
                {tag.name}
              </SpaLink>
            </li>)}
        </ul>
      </nav>
      {tags && <nav className={styles.mobileWrapper} data-testid="mobile-navigation">
          <ul className={styles.tagList}>
            {tags.length > 0 && <li className={classnames(styles.listitem, styles.dropDownListItem)}>
                <DropDown buttonStyling={styles.tagLink} activeButtonStyling={styles.isActive} onLinkClick={selectedCategory => {
            categoryTagsMenuClick(categoryName, selectedCategory);
          }} isActive={true} buttonText={activeTag ? activeTag.name : ``} items={tags} testId="mobile-dropdown-menu" caretColor={'dark'} alignDropDown="left" />
              </li>}
          </ul>
        </nav>}
    </>;
};
export default CategoryTags;